<div class="cohort_entities_details">
  <div
    *ngIf="header"
    class="cohort_entities_details__header lx-body-bold"
    id="modal-basic-title">
    {{ header }}
  </div>

  <div
    *ngIf="subHeader"
    class="lx-subheader"
    [style.color]="headerColor"
    [style.padding-top]="padding">
    {{ subHeader }}
  </div>

  <ng-container *ngIf="setting">
    <span class="cohort_entities_details__setting extra-space lx-body">
      Managed by setting:
    </span>
    <span class="cohort_entities_details__setting-name lx-body-bold">{{ setting }}</span>
  </ng-container>

  <div
    class="cohort_entities_details__entities_list lx-body"
    [ngClass]="{ removable: enableRemove }">
    <ng-container
      *ngFor="let entity of entities"
      class="lx-body">
      <span
        class="cohort_entities_details__path"
        [title]="entity.id">
        {{ getEntityPathWithoutEntityName(entity) }}
        <span class="cohort_entities_details__path__name lx-body-bold">
          {{ entity.name }}
        </span>
      </span>
      <button
        *ngIf="enableRemove"
        class="cohort_entities_details__remove icon_button"
        type="button"
        (click)="removeEntity(entity)">
        <i class="lx-icon lx-trash"></i>
      </button>
    </ng-container>

    <ng-container
      *ngFor="let legacyEntity of legacyEntities"
      class="lx-body">
      <span class="cohort_entities_details__path">{{ legacyEntity.id }}</span>
      <button
        *ngIf="enableRemove"
        class="cohort_entities_details__remove icon_button"
        type="button"
        (click)="removeLegacyCohortEntity(legacyEntity)">
        <i class="lx-icon lx-trash"></i>
      </button>
    </ng-container>
  </div>
</div>
